import { render, staticRenderFns } from "./editDepositTable.vue?vue&type=template&id=0c0146b9"
import script from "./editDepositTable.vue?vue&type=script&lang=js"
export * from "./editDepositTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports